import React from 'react'
import Spinner from 'react-bootstrap/esm/Spinner';
import HtmlDecode from '../../../Utils/HtmlDecode';
import LazyImage from '../../../Components/LazyImage';
import useGetCodeContext from "../../../Hooks/ContextHooks/General/useGetCodeContext"
import { useFetchData } from '../../../Hooks/Main/useFetchData';
const imageUrl = process.env.REACT_APP_FILE_URL

function DiasporaCommunity() {
    const { code } = useGetCodeContext()
  const { data, isLoading } = useFetchData(`getAboutData?a=${code.diaspora}`);
  // console.log("diaspora===", data)
  return !isLoading ? (
    <div className="container-fluid p-0">
      <div className="p-0 position-relative d-flex justify-content-center">
        {data && data[ 0 ]?.images && (
            <LazyImage
              src={`${imageUrl}${data[0]?.images?.file}`}
              style={{
                aspectRatio: "5/1",
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
              }}
          />
        )}

      
        <div className="image-frame__wrapper">
          <h2>Diaspora Community</h2>
        </div>
      </div>
      <div className="container mb-5">
        <div className="row mt-4 mx-1">
          {/* <h4>The Diaspora Community</h4> */}
          <div className="col-md-12 mb-3">
            {data && data[0]?.localContent?.map((content, index) => {
                    return (
                        <div key={index}>
                          <h5 className="text-title fw-light">{content?.title}</h5>
                          <span
                              dangerouslySetInnerHTML={{
                              __html: HtmlDecode(content?.content),
                              }}
                          />
                        </div>
                    );
                    })}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex justify-content-center mt-3">
      <Spinner animation="grow" className="me-2" />
      Loading Content...
    </div>
  );
}

export default DiasporaCommunity